import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
const steps = ["Review the six volumes.", "Explore the assessment frameworks.", "Examine the red-flag reference.", "Use the worksheets to organize your learning.", "Work through the educational case scenarios."];
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-174" data-mp="2ed04lmhxrs71">
      <div className="mx-auto max-w-3xl text-center" data-id="element-175" data-mp="2eci1c5wuwdpm">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full bg-success text-white ring-8 ring-successSoft" data-id="element-176" data-mp="2jbl39hhji3td">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-177" data-mp="2obz1y8x941eq" />
          <span className="mt-1 font-display text-lg font-black leading-none" data-id="element-178" data-mp="2sbreewprmrpd">7 DAYS</span>
        </div>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-success sm:text-sm" data-id="element-179" data-mp="ty7v1h6b3vmz">
          Your purchase is protected by a 7-day guarantee
        </p>
        <h2 className="mt-3 font-display text-[30px] font-black leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-180" data-mp="3sl6k7uhax7tr">
          Explore the Material Before You Decide
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink/85" data-id="element-181" data-mp="3nsvh6ir9l5wz">
          I want you to have the opportunity to review what I’ve created and decide whether it fits your educational needs.
          That’s why your purchase is covered by a <strong data-id="element-182" data-mp="ffg6n7t5ir29">7-day money-back guarantee.</strong>
        </p>

        <div className="mx-auto mt-8 max-w-md rounded-3xl bg-successSoft p-6 text-left" data-id="element-183" data-mp="fcka9nwycafx">
          <p className="font-display text-lg font-extrabold text-ink" data-id="element-184" data-mp="adqshjamtx9y">After purchasing, you can:</p>
          <ul className="mt-3 space-y-2.5" data-id="element-185" data-mp="5itlsj0ts008">
            {steps.map(s => <li key={s} className="flex gap-2.5 text-base text-ink" data-id="element-186" data-mp="h496yxyfea1">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-187" data-mp="2q77uwqoiw3z6" />
                {s}
              </li>)}
          </ul>
        </div>

        <p className="mt-8 text-base leading-relaxed text-muted" data-id="element-188" data-mp="1d8pbtesqzhrp">
          If you decide within seven days that the collection isn’t right for you, contact us within the guarantee period to
          request a refund in accordance with the published refund policy.
        </p>

        <SectionCta label="Get Access With a 7-Day Guarantee" data-id="element-189" data-mp="13cm6k02ln30j" />
      </div>
    </section>;
}